import { FileText } from "lucide-react";

export const SALE_STATUS = {
  AWAITING_BUYER: ["Menunggu Pilihan Pembeli (Investor)", "amber"],
  BUYER_SET: ["Pembeli Ditentukan - Catat Penjualan", "blue"],
  SALE_RECORDED: ["Penjualan Tercatat - Siap Dihitung", "blue"],
  CALCULATING: ["Sedang Dihitung", "slate"],
  AWAITING_TRANSFER: ["Menunggu Transfer PT SJI", "amber"],
  AWAITING_REPORT: ["Menunggu Laporan Pembagian Pengelola", "amber"],
  PAID: ["Lunas - Ditransfer PT SJI", "green"],
  REPORTED: ["Dilaporkan Pengelola", "green"],
  NO_DISTRIBUTION: ["Tidak Ada Dana Dibagikan", "slate"],
};
export const CONTRACT_STATUS = {
  DRAFT: ["Draf", "slate"], SUBMITTED_TO_INVESTOR: ["Menunggu Persetujuan Investor", "amber"],
  INVESTOR_CONFIRMED: ["Disetujui Investor · Review PT SJI", "blue"], REVISION_REQUIRED: ["Perlu Revisi", "red"],
  CANCELLED: ["Dibatalkan", "slate"], LOCKED: ["Skema Aktif — Terkunci", "green"],
};
export const ACCOUNT_STATUS = {
  MISSING: ["Belum Diisi", "slate"], PENDING: ["Menunggu Verifikasi PT SJI", "amber"],
  VERIFIED: ["Terverifikasi", "green"], REJECTED: ["Ditolak", "red"],
};
export const PAYOUT_STATUS = { PENDING: ["Belum Dibayar", "amber"], TRANSFERRED: ["Ditransfer PT SJI", "green"], REPORTED: ["Dilaporkan Pengelola", "green"], RECORDED: ["Dicatat terpisah oleh PT SJI (pembeli)", "blue"] };
export const RECIPIENT_LABELS = { INVESTOR: "Pemodal", MANAGER: "Pengelola (Kelompok Tani/Koperasi)", LANDOWNER: "Pemilik Lahan" };
export const PAYOUT_LABELS = { ...RECIPIENT_LABELS, MANAGER_COST: "Penggantian Biaya Operasional (ke rekening Pengelola)", PROJECT_RESERVE: "Cadangan Kebun (ke rekening Pengelola)", PLATFORM_FEE: "Bagian PT SJI (Imbalan Jasa)" };
export const SCHEME_NAMES = { A: "Opsi A", B: "Opsi B", C: "Opsi C", CUSTOM: "Custom", FINAL: "Skema Final Salimbado Farm" };
export const PRODUCT_FORMS = { CHERRY: "Cherry", GABAH: "Gabah", GREEN_BEAN: "Green Bean" };
export const BUYER_LABELS = { PT_SJI: "PT SJI", OTHER: "Pembeli Lain" };
export const COST_LABELS = {
  PEMELIHARAAN: "Pemeliharaan", PUPUK: "Pupuk", PESTISIDA: "Pestisida", TENAGA_KERJA: "Tenaga Kerja",
  PANEN: "Panen", PASCAPANEN: "Pascapanen", TRANSPORT: "Transportasi", LAINNYA: "Lainnya",
};
export const pct = (bp) => `${(bp / 100).toLocaleString("id-ID")}%`;

const TONES = {
  green: "bg-emerald-50 text-emerald-700 border-emerald-200", amber: "bg-amber-50 text-amber-800 border-amber-200",
  blue: "bg-blue-50 text-blue-700 border-blue-200", red: "bg-red-50 text-red-700 border-red-200", slate: "bg-slate-100 text-slate-700 border-slate-200",
};

export const Pill = ({ map, value, testid }) => {
  const [label, tone] = map[value] || [value || "-", "slate"];
  return <span className={`inline-flex items-center border font-semibold px-2.5 py-0.5 rounded-full text-xs whitespace-nowrap ${TONES[tone]}`} data-testid={testid}>{label}</span>;
};

export const ProofLink = ({ id, label = "Lihat bukti", testid }) => id ? (
  <a href={`${process.env.REACT_APP_BACKEND_URL}/api/profit/files/${id}`} target="_blank" rel="noreferrer"
    className="inline-flex items-center gap-1 text-sm font-semibold text-emerald-800 hover:underline" data-testid={testid}>
    <FileText className="h-3.5 w-3.5" />{label}
  </a>
) : <span className="text-xs text-slate-400">Tanpa bukti</span>;

export const Section = ({ title, action, children, testid }) => (
  <section className="bg-white border border-slate-200/80 rounded-xl p-4 sm:p-6" data-testid={testid}>
    <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
      <h2 className="text-base md:text-lg font-bold text-slate-900">{title}</h2>
      {action}
    </div>
    {children}
  </section>
);

export const Disclaimer = ({ text }) => (
  <p className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-xs sm:text-sm text-amber-900" data-testid="profit-disclaimer">{text}</p>
);

export const today = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`; };
